import React from 'react';
import { useFetchOption } from '../hooks/useFetchOption';

function InfoCard({ geoserverUrl, layerName, mapData, option, color }) {

const valueData = useFetchOption(geoserverUrl, layerName, mapData.variable, option);

if (valueData !== '') {
    return (
        <div style={{ 
        borderBottom: `4px solid ${color}`, 
        padding: '10px', 
        marginBottom: '10px', 
        width: '93%',
        borderBottomColor: color, // Solo se aplica color al borde inferior
        borderBottomWidth: '2px', // Se establece el ancho del borde inferior
        boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)' // Añadida sombra
        }}>
        <div style={{ fontSize: '30px', textAlign: 'center', fontWeight: 'bold', marginBottom: '5px', }}>{mapData.type==='numeric' ? valueData + ' ' + mapData.unit : valueData}</div>
        </div>
    );
}
}

export default InfoCard;
